import React from 'react';
import styled from 'styled-components';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import Search from './Search';

const Container = styled.div`
	width: 100%;
	max-width: 1280px;
	margin: 0 auto;
	padding: 0 16px;
`;

const Nav = styled.nav`
	display: flex;
	/*justify-content: space-between;*/
	flex-direction: row;
	padding-top: 64px;

	@media (max-width: 719px) {
		flex-direction: column;
		justify-content: flex-start;
	}
`;

const Logo = styled.div`
	flex: 0 176px;
	max-height: 29px;
	padding-top: 11px;

	@media (max-width: 719px) {
		padding-top: 0px;
		margin-bottom: 32px;
	}
`;

const Divider = styled.hr`
	width: 100%;
	height: 1px;
	margin: 16px 0;
	background: #dddddd;
	border: 0;
`;

function Navbar(props) {
	return (
		<div>
			<Nav>
				<Logo>
					<Link to="/">
						<svg
							width="76"
							height="29"
							viewBox="0 0 76 29"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M4.03995 8.294V0.197998H0.475952V11.088H13.852V8.294H4.03995Z"
								fill="black"
							/>
							<path d="M19.8521 0V2.794H29.5541V11.286H33.0521V0H19.8521Z" fill="black" />
							<path
								d="M41.052 0.165001V11.121H54.252V0.165001H41.052ZM50.732 2.959V8.327H44.572V2.959H50.732Z"
								fill="black"
							/>
							<path
								d="M65.816 8.294V0.197998H62.252V11.088H75.628V8.294H65.816Z"
								fill="black"
							/>
							<path
								d="M1.164 26H2.484V21.836C2.484 20.876 2.376 19.856 2.304 18.944H2.364L3.288 20.792L6.216 26H7.644V17.156H6.324V21.284C6.324 22.244 6.432 23.312 6.504 24.224H6.444L5.52 22.352L2.592 17.156H1.164V26ZM12.7365 26.156C14.6925 26.156 16.0125 25.088 16.0125 22.208V17.156H14.6685V22.304C14.6685 24.296 13.8525 24.944 12.7365 24.944C11.6325 24.944 10.8405 24.296 10.8405 22.304V17.156H9.4485V22.208C9.4485 25.088 10.7805 26.156 12.7365 26.156ZM21.4173 26.156C22.6293 26.156 23.6253 25.712 24.2133 25.124V21.296H21.2013V22.436H22.9533V24.512C22.6413 24.788 22.1013 24.944 21.5613 24.944C19.7373 24.944 18.7653 23.66 18.7653 21.56C18.7653 19.484 19.8573 18.212 21.5013 18.212C22.3533 18.212 22.8933 18.56 23.3373 19.004L24.0813 18.116C23.5413 17.552 22.7013 17 21.4533 17C19.1133 17 17.3373 18.728 17.3373 21.608C17.3373 24.5 19.0653 26.156 21.4173 26.156ZM28.9913 26.156C30.9473 26.156 32.2673 25.088 32.2673 22.208V17.156H30.9233V22.304C30.9233 24.296 30.1073 24.944 28.9913 24.944C27.8873 24.944 27.0953 24.296 27.0953 22.304V17.156H25.7033V22.208C25.7033 25.088 27.0353 26.156 28.9913 26.156ZM34.4266 26.156C34.9426 26.156 35.3506 25.76 35.3506 25.196C35.3506 24.62 34.9426 24.212 34.4266 24.212C33.9106 24.212 33.5026 24.62 33.5026 25.196C33.5026 25.76 33.9106 26.156 34.4266 26.156ZM36.8968 26H38.1448V21.632C38.1448 20.84 38.0368 19.7 37.9768 18.896H38.0248L38.7208 20.936L40.2688 25.148H41.1328L42.6688 20.936L43.3768 18.896H43.4248C43.3528 19.7 43.2448 20.84 43.2448 21.632V26H44.5408V17.156H42.9328L41.3368 21.632C41.1328 22.22 40.9648 22.82 40.7608 23.408H40.7008C40.4968 22.82 40.3168 22.22 40.1128 21.632L38.4928 17.156H36.8968V26ZM49.7377 26.156C52.0057 26.156 53.5897 24.392 53.5897 21.548C53.5897 18.704 52.0057 17 49.7377 17C47.4697 17 45.8977 18.704 45.8977 21.548C45.8977 24.392 47.4697 26.156 49.7377 26.156ZM49.7377 24.944C48.2737 24.944 47.3257 23.612 47.3257 21.548C47.3257 19.472 48.2737 18.212 49.7377 18.212C51.2017 18.212 52.1617 19.472 52.1617 21.548C52.1617 23.612 51.2017 24.944 49.7377 24.944ZM54.9446 26H56.2646V21.836C56.2646 20.876 56.1566 19.856 56.0846 18.944H56.1446L57.0686 20.792L59.9966 26H61.4246V17.156H60.1046V21.284C60.1046 22.244 60.2126 23.312 60.2846 24.224H60.2246L59.3006 22.352L56.3726 17.156H54.9446V26ZM63.2771 26H68.6291V24.824H64.6691V21.968H67.9091V20.792H64.6691V18.332H68.4971V17.156H63.2771V26ZM71.4444 26H72.8364V22.652L75.5004 17.156H74.0484L73.0164 19.508C72.7524 20.168 72.4644 20.78 72.1764 21.452H72.1284C71.8284 20.78 71.5764 20.168 71.3004 19.508L70.2804 17.156H68.7924L71.4444 22.652V26Z"
								fill="black"
							/>
						</svg>
					</Link>
				</Logo>
				{props.isSearchEnabled && (
					<Search searchInputValue={props.searchInputValue} onSearchChange={props.onSearchChange} />
				)}
				{/* {true && <Search />} */}
			</Nav>
			{props.isSearchEnabled && <Divider />}
		</div>
	);
}

export default Navbar;
